module.exports = __webpack_public_path__ + "static/media/DN CTC Head Support[8905].f063e89f.jpg";